import styled from "styled-components";

import { DescriptionGridItemLabel } from "@/components/ui/DescriptionGrid/DescriptionGridItemLabel";
import { DescriptionGridItemValue } from "@/components/ui/DescriptionGrid/DescriptionGridItemValue";

const DescriptionGridItemStyled = styled.div<{ $colSpan: number }>`
    display: grid;
    align-items: flex-start;
    grid-column: ${({ $colSpan }) => `span ${$colSpan}`};
    grid-template-rows: 1fr max-content;
    gap: 0.25rem;
`;

type Props = {
    title: string;
    children: React.ReactNode;
    colSpan?: number;
    isValueMultiline?: boolean;
};

const DescriptionGridItem = (props: Props) => {
    const { title, children, colSpan, isValueMultiline } = props;

    if (children === null || children === undefined || children === "") {
        return <div style={{ gridColumn: `span ${colSpan}` }} />;
    }

    return (
        <DescriptionGridItemStyled $colSpan={colSpan ?? 1}>
            <DescriptionGridItemLabel title={title}>{title}</DescriptionGridItemLabel>
            <DescriptionGridItemValue
                isMultiline={isValueMultiline}
                title={typeof children === "string" ? children : undefined}
            >
                {children}
            </DescriptionGridItemValue>
        </DescriptionGridItemStyled>
    );
};

export { DescriptionGridItem };
